import * as React from "react"

import { Icons, Main, StyledTopbar, TopbarIcon } from "./Styles"

interface TopbarProps {
  commands?: React.ReactNode
  onClose: () => void
  children?: React.ReactNode
}

const Topbar = ({ commands, onClose, children }: TopbarProps): JSX.Element => (
  <StyledTopbar>
    <Main>{children}</Main>

    <Icons>
      {commands}
      <TopbarIcon code="close" onClick={onClose} />
    </Icons>
  </StyledTopbar>
)

export default Topbar
